import { stringify } from "qs"
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import getBaseUrl from "./getBaseUrl"
import type { State as AuthState } from "@/auth/slice"
import { getTimeZone } from "@/utils"

const paramsSerializer = (params: Record<string, unknown>) => {
  const sanitizedParams: Record<string, unknown> = {}

  Object.keys(params).forEach((paramKey) => {
    if (params[paramKey] === true) {
      // For PHP compatibility
      sanitizedParams[paramKey] = "1"
    } else if (params[paramKey] === false) {
      // For PHP compatibility
      sanitizedParams[paramKey] = "0"
    } else {
      sanitizedParams[paramKey] = params[paramKey]
    }
  })

  return stringify(sanitizedParams, {
    arrayFormat: "brackets",
    skipNulls: true,
    // TODO: Verify date serialisation
  })
}

const prepareCommonHeaders = (headers: Headers) => {
  headers.set("TimeZone", getTimeZone()) // Unused, but nice to have

  return headers
}

type BaseQueryOptions = {
  withoutAuth: boolean
}

export default ({ withoutAuth }: BaseQueryOptions) =>
  fetchBaseQuery({
    baseUrl: getBaseUrl(),
    prepareHeaders: (headers, { getState }) => {
      const { token, tenantSlug } = (getState() as { auth: AuthState }).auth

      if (!withoutAuth && token) {
        headers.set("Authorization", `Bearer ${token}`)
      }
      if (tenantSlug) {
        headers.set("Tenant-Slug", tenantSlug)
      }

      return prepareCommonHeaders(headers)
    },
    paramsSerializer,
  })
